<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li *ngIf="getUserCurrent().company.uniqid === 'admin'" class="breadcrumb-item">
            <a routerLink="/{{getUserCurrent().company.uniqid}}/company">List companies</a>
          </li>
          <li class="breadcrumb-item">
            Precision Time Exchange - profile
          </li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div class="pb-2 mb-3 border-bottom">
        <h3>
          <b> Precision Time Exchange - profile - {{ companyName }}</b>
        </h3>
      </div>
      <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
        The precision time exchange profile is currently not available.
        <button (click)="error = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="errorExport" class="alert alert-danger alert-dismissible fade show">
        Error while trying to download file
        <button (click)="errorExport = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="successCreateJira" class="alert alert-success alert-dismissible fade show">
        Jira ticket number. {{ jiraIssueCode }}  created:
        <a href="{{ jiraLink }}" target="_blank"> jira link </a>
        <button (click)="successCreateJira = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="errorPopup" class="alert alert-danger alert-dismissible fade show">
        The item data is currently not available.
        <button (click)="errorPopup = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="jiraCreationError" class="alert alert-danger alert-dismissible fade show">
      A JIRA ticket could not be created. You may leave this page open and retry later. We are informing the support.
      <button (click)="jiraCreationError = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
      <div *ngIf="!loading">
        <div class="mb-3 profile-toolbar">
          <div class="toolbar-group toolbar-group--neutral">
            <button (click)="op.toggle($event)" label="Select Order Forms" pButton></button>
            <button (click)="exportAsExcel()" label="Export as XLS" pButton></button>
          </div>

          <div class="toolbar-group toolbar-group--support">
            <ng-container *ngIf="displayJiraFeature">
              <ng-container *roles="['ROLE_CLIENT']">
                <button (click)="openSendJiraPopup()" class="toolbar-btn" type="button">
                  <i class="fa fa-ticket" style="font-size: 12px"></i> Create a support ticket (JIRA)
                </button>
              </ng-container>
            </ng-container>
            <button pButton label="Legend" (click)="legendPanel.toggle($event)" type="button"></button>
          </div>
        </div>
        <p-overlayPanel #op [dismissable]="true">
          <p-table (onHeaderCheckboxToggle)="onHeaderCheckbox($event)" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                   [(selection)]="selectedOrderForms" [columns]="orderFormsCols"
                   [value]="orderForms" dataKey="identificationNumber">
            <ng-template let-columns pTemplate="header">
              <tr>
                <th style="width: 3em">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of columns" [style.width]="col.width">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template let-columns="columns" let-rowData pTemplate="body">
              <tr [pSelectableRow]="rowData">
                <td>
                  <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of columns">
                  {{ rowData[col.field] }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-overlayPanel>
        <p-table [columns]="selectedCPopCols" [value]="exProducts">
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width:40px">
              <col style="width:70px">
              <col *ngFor="let col of selectedCPopCols" style="width:20px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th [attr.colspan]="totalNbOfColumns+2" style="text-align: center;">Delivered to:</th>
            </tr>
            <tr>
              <th colspan="2"> Datacenter</th>
              <th *ngFor="let col of selectedCPopCols" [ngClass]="{'background-grey': isColumnHighlighted(col)}"
                  style="padding-left: 3px;text-align: center; font-size: 9px;">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-exProduct let-rowIndex="rowIndex" pTemplate="body">
            <tr [pSelectableRow]="exProduct">
              <td *ngIf="rowGroupMetadata[exProduct.exchangeName].index === rowIndex"
                  [attr.rowspan]="rowGroupMetadata[exProduct.exchangeName].size">
                {{ exProduct.exchangeName }}
              </td>
              <td (click)="displayItem($event, exProduct, null, op1)"
                  (mouseleave)="onCellLeave()"
                  (mouseover)="onCellHover(null, rowIndex)"
                  [ngStyle]="{'background-color': isRowHighlighted(rowIndex) ? '#F1EFEB' : 'transparent'}"
                  style="width:auto; white-space: nowrap;">
                {{ exProduct.productName }}
              </td>
              <td (click)="displayItem($event, exProduct, col, op1)" (close)="op1.hide()" (mouseleave)="onCellLeave()"
                  (mouseover)="onCellHover(col, rowIndex)"
                  *ngFor="let col of selectedCPopCols"
                  [ngClass]="exProduct[col.field] ? getCellClasses(exProduct, col.field) : null"
                  class="no-padding"
                  style="cursor: pointer;">
                <div *ngIf="getIsDisplayed(exProduct,col.field)" style="padding-left: 60%">
                  <ng-container>
                    {{ exProduct[col.field] ? getCellClasses(exProduct, col.field).substr(0, 1).toUpperCase() : '' }}
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-overlayPanel #op1 [dismissable]="true" [style]="{width: '35%'}" appendTo="body">
          <p-tabView>
            <p-tabPanel *ngFor="let tab of tabData; let i = index" [header]="tab.header" [selected]="i == 0">
              <div class="item-info">
                <p>Status: {{ tab.status }} </p>
                <p>Type: <span id="left-side"><img alt="" src='{{tab.typeImg}}'
                                                   style="width: 5%;"> {{ tab.type }}</span>
                </p>
                <p>Carrier: {{ tab.carrier }}</p>
                <p style="line-break: anywhere;">Cross-connect ID: {{ tab.crossConnectId }}</p>
                <p>Technical POPs:<span [pTooltip]="technicalPopService.getCageTooltip(tab.technicalPop)">{{ tab.technicalPop }} </span></p>
              </div>
              <div *ngIf="tab.histories?.length != 0" class="mt-2">
                <p class="item-info">Service history</p>
                <p-table [columns]="historiesCols" [scrollable]="true" [value]="tab.histories" scrollHeight="200px">
                  <ng-template let-columns pTemplate="header">
                    <tr>
                      <th *ngFor="let col of columns" [style.width]="col.width">
                        {{ col.header }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template let-columns="columns" let-rowData pTemplate="body">
                    <tr>
                      <td *ngFor="let col of columns" [style.width]="col.width">
                        {{ rowData[col.field] }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-tabPanel>
          </p-tabView>
        </p-overlayPanel>
      </div>
    </div>
  </div>
</div>
<p-overlayPanel #legendPanel [dismissable]="true" appendTo="body" styleClass="legend">
  <div class="legend-section">
    <div class="legend-section-title">Letters / Colors</div>
    <ul class="legend-list">
      <li><span class="icon icon-green"></span><span class="legend-label">C / Green: active service</span></li>
      <li><span class="icon icon-grey"></span><span class="legend-label">D / Grey: terminated service</span></li>
      <li><span class="icon icon-yellow"></span><span class="legend-label">N / Yellow: new service</span></li>
    </ul>
  </div>
  <div class="legend-section">
    <div class="legend-section-title">Icons</div>
    <ul class="legend-list">
      <li><span class="icon icon-rf"></span><span class="legend-label">RF - Radio Frequency</span></li>
      <li class="legend-divider"><span class="icon fa fa-exclamation-circle"></span><span class="legend-label">Ongoing outage</span></li>
      <li><span class="icon fa fa-question-circle"></span><span class="legend-label">Ongoing announcement</span></li>
      <li><span class="icon fa fa-file"></span><span class="legend-label">Multiple feeds/carriers</span></li>
    </ul>
  </div>
</p-overlayPanel>

<p-dialog [(visible)]="isJiraPopUp"
          [baseZIndex]="10000"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'auto','max-width': '80vw',
                           'max-height': '80vh','min-height':'300px'}"
          [draggable]="false"
          [maximizable]="true"
          [modal]="true"
          [resizable]="true">

  <p-header>
    <div class="row">
      <div class="col-md-2" >
        <img alt="" class="jira-logo" src="../../../assets/images/logo-jira.png">
      </div>
      <div class="col-md-10 jira-header">
        Create a new Jira issue
      </div> </div>
  </p-header>
  <div class="jira-body">
    <div class="modal-body">
      <p *ngIf="isSendToJiraDisabled"> <label class="required-items-alert"> Please fill in all required fields</label></p>
      <label *ngIf="loggedInUser" class="custom-label mt-2 mb-2"> Reporter: {{ loggedInUser.username }}</label>
        <label class="jira-text">Cross Connects:</label>
        <p-multiSelect (onChange)="setIsSendToJiraFlag()" [(ngModel)]="selectedXcoForJira"
                       placeholder="Select Cross Connect"
                       [filter]="true" [options]="crossConnectItemForJira"
                       [panelStyle]="{'width':'95em'}"
                       [style]="{'width':'95em'}" class="p-multiSelect" required></p-multiSelect>
      <label class="custom-label mt-2 " for="description">Description:</label>
      <p-editor name="description" [(ngModel)]="jiraCustomDescription" [style]="{ height: '80px' }"
                (onTextChange)="setIsSendToJiraFlag()" id="description" placeholder="Enter the description"></p-editor>
      <label class="jira-text mt-2" for="priority">Priority:</label>
      <select class="ui-dropdown with-icons" id="priority" name="priority" [(ngModel)]="selectedPriority">
        <option data-icon="fas fa-life-ring" value="support">Support</option>
        <option data-icon="fas fa-exclamation-triangle" value="urgent">Urgent</option>
      </select>
    </div>
    <div style="display: flex; justify-content: flex-end; align-items: center; margin-top: 1rem;">
      <button (click)="createIssue()" class="create-button"  [disabled]=isSendToJiraDisabled appNoDblClick>Send to JIRA</button>
      <button (click)="cancel()" class="cancel-button">Cancel</button>
    </div>
  </div>
</p-dialog>
